import Vue from 'vue'
import Warn from "@/components/common/warn.vue"

const warnBox = Vue.extend(Warn);

Warn.install = function(options){
    if (options === undefined || options === null) {
        options = {
            warnText: ''
        }
    } else if (typeof options === 'string' || typeof options === 'number') {
        options = {
            warnText: options
        }
    }

    let instance = new warnBox({
        data: options
    }).$mount()

    document.getElementById("app").appendChild(instance.$el)

    Vue.nextTick(() => {
        setTimeout(()=>{
            instance.isShow = false
        },1200);
    })
}

export default Warn;


// WEBPACK FOOTER //
// ./src/assets/js/modules/warn.js